module.exports = __webpack_public_path__ + "img/main_product_women1.cff6ac78.png";